import type { LoginBranding } from '@e-learning/shared';
import { designTokens } from '@e-learning/shared';
import type { TFunction } from 'i18next';

import logoFera from '../../../../assets/logo-fera.png';

/** Marca fixa FERA (cliente fixo B2B) — mesmo core, config única por produto */
export function getDefaultLoginBranding(t: TFunction): LoginBranding {
  return {
    logo: logoFera,
    title: t('login.branding.title'),
    subtitle: t('login.branding.subtitle'),
    primaryColor: designTokens.palette.primary.main,
    footerText: t('login.branding.footer_text'),
  };
}
